// Options for screen-recording polish (backend/screen_polish.py). The ids must
// match ZOOM_LEVELS and FRAME_STYLES there; the API rejects anything else.
export const ZOOM_OPTIONS = [
  { v: "off", l: "Off — no zoom" },
  { v: "subtle", l: "Subtle (1.35×)" },
  { v: "normal", l: "Normal (1.7×)" },
  { v: "strong", l: "Strong (2.1×)" },
];

// `swatch` is the gradient the renderer draws, so the picker previews it.
export const FRAME_OPTIONS = [
  { v: "none", l: "None — full frame", swatch: null },
  { v: "midnight", l: "Midnight", swatch: ["#0F172A", "#334155"] },
  { v: "ocean", l: "Ocean", swatch: ["#0B3C6D", "#1FA2C4"] },
  { v: "sunset", l: "Sunset", swatch: ["#F0616D", "#F9B47A"] },
  { v: "paper", l: "Paper", swatch: ["#F5F2EA", "#DDD6C8"] },
];
